import Vue from 'vue'
import store from 'store'

/* eslint-disable no-undef */
console.log('isEnterprise', process.env.IS_ENTERPRISE)

Vue.mixin({
  computed: {
    loggedIn () {
      return store.getters['loggedIn']
    },
    isEnterprise () {
      /* eslint-disable no-undef */
      return !!process.env.IS_ENTERPRISE
    }
  },
  methods: {
    hasPermission (permission, serverId) {
      const hasPermission = store.getters['hasPermission']({ permission, serverId })

      if (!hasPermission) {
        console.warn(`No permission: ${permission}`)
      }

      return hasPermission
    },
    showSuccess (message) {
      store.commit('SHOW_NOTIFICATION', { message, type: 'success' })
    },
    showInfo (message) {
      store.commit('SHOW_NOTIFICATION', { message, type: 'info' })
    },
    showError (message) {
      store.commit('SHOW_NOTIFICATION', { message, type: 'error' })
    },
    showWarning (message) {
      store.commit('SHOW_NOTIFICATION', { message, type: 'warning' })
    }
  }
})



// WEBPACK FOOTER //
// ./src/mixin.js